import React from "react";
import { Link as RouterLink } from "react-router-dom";
// External Components
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Typography from "@mui/material/Typography";
// Internal
import CoachingLink from "./CoachingLink";
var TitleBar = function (_a) {
    var children = _a.children, backPage = _a.backPage, title = _a.title, coachingTipHeader = _a.coachingTipHeader;
    return (React.createElement(Box, { alignItems: "center", bgcolor: "background.paper", display: "flex", justifyContent: "space-between", paddingX: 3, paddingY: 1 },
        !backPage ? (React.createElement(Typography, { variant: "h5" }, title)) : (React.createElement(Breadcrumbs, { separator: React.createElement(NavigateNextIcon, { fontSize: "small" }) },
            backPage.map(function (_a) {
                var href = _a.href, name = _a.name;
                return href ? (React.createElement(Link, { component: RouterLink, key: name, to: href }, name)) : (React.createElement(Typography, { key: name, color: "textPrimary" }, name));
            }),
            React.createElement(Typography, { color: "textPrimary" }, title))),
        React.createElement(CoachingLink, { title: title, coachingTipHeader: coachingTipHeader != null ? coachingTipHeader : "" }, children)));
};
export default TitleBar;
//# sourceMappingURL=index.js.map